module.exports = __webpack_public_path__ + "static/How2Social-09cd77cb1a41a22b60dd0f3d254819a9.png";